/**
 * @documental
 * @export Placeholder
 * @name
 * RadioGroup.Placeholder
 */

import { FC, ReactElement } from "react";
import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { InputContainerPlaceholder } from "../shared/InputContainer/InputContainerPlaceholder";
import styles from "./styles.module.scss";
import { SharedRadioPlaceholder } from "../Radio/SharedRadioPlaceholder";

/**
 * The `Placeholder` component properties.
 */

export interface PlaceholderProps extends BaseProps {
  /**
   * The number of options to show in the placeholder.
   */
  readonly optionCount?: number;
}

/**
 * A loading placeholder for the `RadioGroup` component.
 */
export const Placeholder: FC<PlaceholderProps> = (props) => {
  const { optionCount = 2 } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.RadioGroupPlaceholder, "radio-group", "placeholder"],
    testIdPrefix: "radio-group",
  });

  const items: Array<ReactElement> = [];
  for (let i = 0; i < optionCount; i++) {
    items.push(<SharedRadioPlaceholder className="item" key={i} />);
  }

  return (
    <InputContainerPlaceholder {...getBasePropsFromHtmlProps(baseHtmlProps)}>
      <Stack spacing="none">{items}</Stack>
    </InputContainerPlaceholder>
  );
};
